import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { DeviceDetectorService } from 'ngx-device-detector'

import { AppComponent } from './app.component'

import { SharedModule } from '@shared/shared.module'
import { CoreModule } from '@core/core.module'
import { AppRoutingModule } from './app-routing.module'
import { AuthModule } from './modules/auth/auth.module'

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserAnimationsModule, AuthModule, AppRoutingModule, SharedModule, CoreModule],
  bootstrap: [AppComponent],
  providers: [DeviceDetectorService, provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}

//...//
